import React from "react"
import { Link } from "gatsby"
import * as styles from "../../styles/section.module.scss"
import { ImList2 } from "react-icons/im"

export default function NavInformatii() {
  return (
    <nav className={styles.sideNav}>
      <div className={styles.sideNavHeader}>
        <ImList2 fontSize={40} />
        <h4>În această secțiune</h4>
      </div>
      <ul className={styles.nav}>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/acte-necesare"
          >
            Acte Necesare
          </Link>
        </li>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/angajari"
          >
            Angajări
          </Link>
        </li>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/anunturi"
          >
            Anunțuri Publice
          </Link>
        </li>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/buget"
          >
            Buget
          </Link>
        </li>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/fiscalitate"
          >
            Fiscalitate
          </Link>
        </li>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/formulare"
          >
            Formulare
          </Link>
        </li>
        <li>
          <Link
            className={styles.link}
            activeClassName="active"
            to="/informatii/rapoarte"
          >
            Rapoarte de Activitate
          </Link>
        </li>
      </ul>
    </nav>
  )
}
